<template>
    <div class="payrollSetting customerBox" ref="payrollSetting">
      <div class="payrollBox">
        <paySequence :process="process"></paySequence>
        <el-tabs v-model="payrollIndex" type="card" editable @edit="handleTabsEdit">
          <el-tab-pane
            :key="item.name"
            v-for="(item, index) in payrollLists"
            :label="item.title"
            :name="item.name"
          >
            <wagesSettings :idx="index" :wages-from.sync="item.datas.wagesFrom" :item-lists.sync="item.datas.itemLists" @changeName="changeName"></wagesSettings>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>

<script>
  import paySequence from "./paySequence"
  import wagesSettings from "./wagesSettings"
  export default {
    name: "payrollSetting",
    components:{paySequence,wagesSettings},
    data(){
      return{
        process:4,//从0开始，第几个步骤
        payrollIndex: '2',
        payrollLists: [{
          title: '一公司',
          name: '1',
          datas:{
            wagesFrom:{
              name:"一公司",
              empty:1,
              org:["org1"],
              lang:1,
            },
            itemLists:[
              {
                id:1,
                itemName:"员工信息",
                itemEnName:"Employee Info",
                itemList:[
                  {
                    id: 1,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "1"
                  }, {
                    id: 2,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "2"
                  }, {
                    id: 3,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "3"
                  }, {
                    id: 4,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "4"
                  }, {
                    id: 5,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "5"
                  }, {
                    id: 6,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "6"
                  },
                  {
                    id: 6,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "7"
                  }]},
              {
                id:2,
                itemName:"收入",
                itemEnName:"Employee Info",
                itemList:[{
                  id: 1,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "1"
                }, {
                  id: 2,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "2"
                }, {
                  id: 3,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "3"
                }, {
                  id: 4,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "4"
                }, {
                  id: 5,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "5"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "6"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "7"
                }]},
              {
                id:3,
                itemName:"社保&公积金",
                itemEnName:"Employee Info",
                itemList:[{
                  id: 1,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "1"
                }, {
                  id: 2,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "2"
                }, {
                  id: 3,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "3"
                }, {
                  id: 4,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "4"
                }, {
                  id: 5,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "5"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "6"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "7"
                }]}
            ]
          }
        }, {
          title: '二公司',
          name: '2',
          datas:{
            wagesFrom:{
              name:"二公司",
              empty:1,
              org:["org2"],
              lang:1,
            },
            itemLists:[
              {
                id:1,
                itemName:"员工信息",
                itemEnName:"Employee Info",
                itemList:[
                  {
                    id: 1,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "1"
                  }, {
                    id: 2,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "2"
                  }, {
                    id: 3,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "3"
                  }, {
                    id: 4,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "4"
                  }, {
                    id: 5,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "5"
                  }, {
                    id: 6,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "6"
                  },
                  {
                    id: 6,
                    name: "养老保险企业部分",
                    enName: "yanglaojinbaoxian",
                    money: "7"
                  }]},
              {
                id:2,
                itemName:"收入",
                itemEnName:"Employee Info",
                itemList:[{
                  id: 1,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "1"
                }, {
                  id: 2,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "2"
                }, {
                  id: 3,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "3"
                }, {
                  id: 4,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "4"
                }, {
                  id: 5,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "5"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "6"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "7"
                }]},
              {
                id:3,
                itemName:"社保&公积金",
                itemEnName:"Employee Info",
                itemList:[{
                  id: 1,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "1"
                }, {
                  id: 2,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "2"
                }, {
                  id: 3,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "3"
                }, {
                  id: 4,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "4"
                }, {
                  id: 5,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "5"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "6"
                }, {
                  id: 6,
                  name: "养老保险企业部分",
                  enName: "yanglaojinbaoxian",
                  money: "7"
                }]}
            ]
          }
        }],
        tabIndex: 2
      }
    },
    methods: {
      handleTabsEdit(targetName, action) {
        if (action === 'add') {
          let newTabName = ++this.tabIndex + '';
          this.payrollLists.push({
            title: '未命名-工资单模板',
            name: newTabName,
            datas:{
              wagesFrom:{},
              itemLists:[]
            }
          });
          this.payrollIndex = newTabName;
        }
        if (action === 'remove') {
          let tabs = this.payrollLists;
          let activeName = this.payrollIndex;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }

          this.payrollIndex = activeName;
          this.payrollLists = tabs.filter(tab => tab.name !== targetName);
        }
      },
      changeName([newName,idx]){
        this.$set(this.payrollLists[idx],"title",newName)
        this.$set(this.payrollLists[idx],"name",newName)
        this.payrollIndex = newName;
        this.$forceUpdate();
      }
    }
  };
</script>

<style scoped>

</style>
